import React, { useCallback, useContext, useEffect, useState } from 'react';
import { shuffle } from 'lodash';
import { Link } from 'react-scroll';
import classNames from 'classnames';
import { range } from 'lodash';
import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import SaleItem from '../components/sale-item';
import ImgPictures from '../components/img-pictures';
import ImgPicture from '../components/img-picture';
import { SaleItemsContext } from '../';
import * as c from '../../ts/const';
gsap.registerPlugin(ScrollTrigger);
/**
 * ふくびき用アイテムの抽出
 */
const getLotterySaleItems = (saleItemListMap) => {
    const result = [];
    Object.keys(saleItemListMap).forEach(key => {
        saleItemListMap[key].forEach(saleItem => {
            // lotteryオプションをもつ商品だけを抽出する
            if (saleItem.lottery) {
                result.push(saleItem);
            }
        });
    });
    return result;
};
/**
 * 空のSPANタグを任意の数生成する
 */
const createSpanElements = (numSpan, key) => {
    return range(numSpan).map((v, i) => (React.createElement("span", { key: `${key}${i}` })));
};
const LotteryBox = () => {
    // セールアイテムリストを取得
    const [saleItemsState] = useContext(SaleItemsContext);
    // ふくびきアイテムリストの初期化
    const [lotteryItem, setLotteryItem] = useState();
    // ルートに設定するクラス名
    const [rootClassName, setRootClassName] = useState('lottery-pickup');
    // ふくびきステータス
    const [isShake, setIsShake] = useState(true);
    const [isOpen, setIsOpen] = useState(false);
    // 箱クリック
    const onClickLotteryBox = useCallback(() => {
        // ぶるぶるを停止して
        setIsShake(false);
        // オープンアニメーションへ移行
        setIsOpen(true);
    }, []);
    // ふくびきアイテムの抽出
    useEffect(() => {
        if (saleItemsState) {
            // セール一覧からふくびき用アイテムを抽出
            const lotteryItemList = getLotterySaleItems(saleItemsState.saleItems);
            if (lotteryItemList.length > 0 && !lotteryItem) {
                // ランダムでひとつ選び値をセットする
                const item = shuffle(lotteryItemList)[0];
                setLotteryItem(item);
            }
        }
    }, [
        saleItemsState
    ]);
    // クラス名の生成
    useEffect(() => {
        setRootClassName(classNames('lottery-pickup', { 'lottery-pickup--shake': isShake }, { 'lottery-pickup--open': isOpen }));
    }, [
        isOpen,
        isShake
    ]);
    return (React.createElement("div", { className: rootClassName, id: "lottery-box" },
        React.createElement("div", { className: 'lottery-pickup__decor' },
            React.createElement(ImgPicture, { fileName: './assets/img/lottery-box/result-decor-md' })),
        React.createElement("div", { className: 'lottery-pickup__wrap' },
            React.createElement("div", { className: 'lottery-pickup__header' },
                React.createElement("div", { className: "a-sale-header" },
                    React.createElement("div", { className: "base-width" },
                        React.createElement(ImgPictures, { fileNameLarge: `./assets/img/head/lottery-box-md`, fileNameSmall: `./assets/img/head/lottery-box-sm`, mediaQueryLarge: c.MEDIA_QUERY_LARGE, mediaQuerySmall: c.MEDIA_QUERY_SMALL, alt: "\u30E9\u30F3\u30C0\u30E0\u30D4\u30C3\u30AF\u30A2\u30C3\u30D7" })))),
            React.createElement("div", { className: 'lottery-pickup__sub-header' },
                React.createElement("div", { className: 'base-width' },
                    React.createElement(ImgPictures, { fileNameLarge: `./assets/img/sub-head/lottery-box-md`, fileNameSmall: `./assets/img/sub-head/lottery-box-sm`, mediaQueryLarge: c.MEDIA_QUERY_LARGE, mediaQuerySmall: c.MEDIA_QUERY_SMALL }))),
            React.createElement("div", { className: 'lottery-pickup__body' },
                React.createElement("div", { className: 'lottery-pickup__main' },
                    React.createElement("div", { className: 'lottery-pickup__main__floater' },
                        React.createElement("a", { id: 'FUKUBIKI_Action_01', className: 'lottery-pickup__box', onClick: onClickLotteryBox },
                            React.createElement(ImgPicture, { fileName: './assets/img/lottery-box/box', lazyload: true })),
                        React.createElement("div", { className: 'lottery-pickup__result' },
                            React.createElement("div", { className: 'lottery-pickup__result__rim' },
                                React.createElement("div", { className: 'lottery-pickup__result__item' }, lotteryItem && (React.createElement(SaleItem, { saleItem: lotteryItem, gaPrefix: 'FUKUBIKI' }))))),
                        React.createElement("div", { className: 'lottery-pickup__smoke' }, createSpanElements(10, 'smoke')),
                        React.createElement("div", { className: 'lottery-pickup__particle' }, createSpanElements(48, 'particle')))),
                React.createElement("div", { className: "lottery-pickup__nav" },
                    React.createElement("div", { className: 'base-width' },
                        React.createElement(Link, { className: "btn-rounded btn-rounded-red", smooth: true, duration: 300, id: 'FUKUBIKI_Action_02', to: 'js-sale-1' }, "\u4ED6\u306E\u30BB\u30FC\u30EB\u30BF\u30A4\u30C8\u30EB\u3082\u30C1\u30A7\u30C3\u30AF\uFF01")))))));
};
export default LotteryBox;
